// extracted by mini-css-extract-plugin
module.exports = {"outer_article":"articlecoaching_outer_article__1FAOy"};